import React, {useEffect, useState} from 'react'
import classes from "./Saved.module.css"
import {useLocation} from 'react-router'
import {JobCard} from '../../../components/JobCard/JobCard'
import {NavText} from '../../../components/NavElements'
import {EmployeeLayout} from "../EmployeeLayout/EmployeeLayout";
import {useMediaQuery} from "@material-ui/core";
import {authAxios} from "../../../API/apiRequest";
import TimeAgo from "javascript-time-ago";
import {Button} from "../../../components/Button/Button";
import {Loading} from "../../../components/Loading/Loading";
import {NoData} from "../../../components/NoData/NoData";

interface Props {
    without?: boolean
}

export const Saved: React.FC<Props> = (props) => {
    const matches = useMediaQuery('(max-width:510px)');
    const [page, setpage] = useState<number>(1);
    const [Load, setLoad] = useState<boolean>(true);
    const [noData, setnoData] = useState<boolean>(false);
    const timeAgo = new TimeAgo('ar-EG')
    const [JopsSaved, setJopsSaved] = useState<{
        hasNext: boolean,
        lastPage: number,
        nextPage: number
        savedJobs: Array<{
            companyImage: string,
            companyName: string,
            createdAt: string,
            field: string,
            id: string,
            jobId: string,
            title: string,
            type: string,
        }>
        total: number
    }>()
    const {pathname} = useLocation()
    useEffect(() => {
        setLoad(true)
        window.scrollTo(0, 0)
        authAxios.get(`/employee/saved?page=${page}`).then((res) => {
            if(res.status === 200 && res.data.savedJobs.length > 0) {
                setJopsSaved(res.data)
                setLoad(false)
            } else if(res.data.savedJobs.length === 0) {
                setnoData(true)
            }
        }).catch(err => {
            console.log(err)
        })
    }, [pathname, page])
    return (
            <>


                <EmployeeLayout>
                    {Load && !noData ? (<Loading></Loading>) : noData ? (<NoData/>) : (
                            <div className={'mxheight100  pb25px animate__animated animate__fadeIn '}>

                                <div className='container   rtl  ' style={{boxSizing: 'border-box'}}>
                                    <h2 className={' text-white'}>المحفوظات</h2>
                                    <div className='d-flex  flex-wrap justify-content-center contain'>

                                        {JopsSaved && JopsSaved.savedJobs.map((j, index) =>
                                                <div key={index}>
                                                    <NavText to={{
                                                        pathname: `/employee/job/${j.jobId}`,
                                                        state: {without: props.without}
                                                    }}>
                                                        <JobCard
                                                                title={j.title}
                                                                companyName={j.companyName}

                                                                time={(timeAgo.format(Date.now() - (Date.now() - new Date(j.createdAt).getTime()))).toString().replace("قبل", '')}

                                                                jobCategory={j.field}
                                                                jobTime={j.type}
                                                        /></NavText></div>)}
                                    </div>

                                </div>

                                {!(JopsSaved && JopsSaved.hasNext) && page === 1 ? "" : (
                                        <div className={'d-flex w-100 justify-content-center'}>
                                            <div className={"my-2 " + classes.pages}>
                                                <Button width={matches ? 150 : undefined}
                                                        height={matches ? 38 : undefined}
                                                        disabled={!(JopsSaved && JopsSaved.hasNext)}
                                                        onPress={() => {
                                                            if(JopsSaved && JopsSaved.hasNext) {
                                                                let num = page;
                                                                num++;
                                                                setpage(num);
                                                            }
                                                        }}
                                                        color='black'>التالي</Button>

                                                <Button width={matches ? 150 : undefined}
                                                        height={matches ? 38 : undefined}
                                                        disabled={page <= 1}
                                                        onPress={() => {
                                                            if(page > 1) {
                                                                let num = page;
                                                                num--;
                                                                setpage(num);
                                                            }
                                                        }}
                                                        color='black'>السابق</Button>

                                            </div>
                                        </div>
                                )}
                            </div>)}

                </EmployeeLayout>


            </>
    )
}

